import * as React from 'react';
export var defaultDialogOptions = {
  preventScroll: true,
  backdrop: {
    color: 'strong-chrome',
    opacity: 0.65,
    zIndex: 700
  }
};
export var initialDialogState = {
  items: []
};
export var DialogStateContext = React.createContext([initialDialogState, function () {}]);
export var DialogStateProvider = function (_a) {
  var _b = _a.initialState,
    initialState = _b === void 0 ? initialDialogState : _b,
    children = _a.children;
  return React.createElement(DialogStateContext.Provider, {
    value: React.useState(initialState)
  }, children);
};